import client_lookups from '@/assets/json/clientLookups.json'
import router from '@/router'
import { useFormStore } from '@/stores/form'
import { defineStore } from 'pinia'
import { computed } from 'vue'

export const useTypingCenterDraftOverrideStore = defineStore('typingCenterOverrideStore', () => {
  const routeVars = computed(() => {
    const {
      params: { serviceId: serviceTransactionId },
      query: { administrativeRegionId }
    } = router.currentRoute.value

    return {
      serviceTransactionId,
      administrativeRegionId,
      withException: false
    }
  })

  async function buildBasePayload() {
    return {
      request: {},
      ...routeVars.value
    }
  }

  async function overrideForm24() {
    const payload = buildBasePayload()
    const formStore = useFormStore()
    const { serviceTransactionId } = routeVars.value
    const {
      sponsorType: { resident },
      familyInvestorServices: { issueVisa }
    } = client_lookups

    const { applicantEmail, monthlyIncome } = formStore.form.values
    const { requestNumber } = formStore.draft

    /**
     * avoid manipulating the payload on update
     */
    if (requestNumber) {
      return formStore.draft
    }

    /**
     * TODO: figure out once we can send form 24
     * web/client/typingCenter/pages/visa/visaRequest.step1Ctrl.js
     * function setSponsorType
     */
    // const sponsorTypeId = serviceTransactionId == issueVisa ? resident : null

    const output = {
      request: {
        ...payload.request,
        ...formStore.form.values,
        serviceTransactionId: serviceTransactionId,
        isWorkSeekerVisaAccompanyAttachmentMandatory: false,
        isBeneficiariesofExemptions: false,
        isWantApplyAsBeneficiariesofExemption: false,
        isUsingSponsorIdentityCard: false,
        studyingCountryId: null,
        studyingDestination: null,
        studyingEmirateId: null,
        tawzeaDeliveryAreaId: null,
        tawzeaDeliveryCityId: null,
        tawzeaDeliveryEmirateId: 2,
        yearsOfExperience: null,
        addNewAddressFlag: false,
        accompanies: [],
        sponsoredEntryStatus: 2,
        eiDorUN: 0,
        isParentInsideUae: 1,
        fatherArabicFullName: null,
        fatherEID: null,
        fatherEnglishFullName: null,
        fatherNationalityId: null,
        fatherPassportNumber: null,
        fatherUnifiedNumber: null,
        governmentalDepartmentId: '',
        motherArabicFullName: null,
        motherDateOfBirth: null,
        motherEID: null,
        motherEnglishFullName: null,
        motherNationalityId: null,
        motherPassportNumber: null,
        motherUnifiedNumber: null,
        monthlyIncome: (monthlyIncome || '').toString().replaceAll(',', ''),
        emailAddress: applicantEmail
      },
      ...routeVars.value
    }

    return output
  }

  const actions = {
    overrideForm24
  }
  return {
    ...actions
  }
})
